import React from 'react';
import "./Footer.css";
import { Link } from "react-router-dom";
import logo from "../images/ignosilogo.webp";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaYoutube,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt
} from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer-premium">
      <div className="footer-container-premium">
        <div className="footer-main-premium">
          <div className="footer-brand-premium">
            <Link to="/" className="footer-logo-premium">
              <img src={logo} alt="IGNOSI Logo" />
            </Link>
            <p className="brand-statement-premium">
              Pioneering the next generation of financial infrastructure. Built with precision at Technopark, Kerala.
            </p>
            <div className="social-pill-premium">
              <a href="https://youtube.com" aria-label="YouTube"><FaYoutube /></a>
              <a href="https://facebook.com" aria-label="Facebook"><FaFacebookF /></a>
              <a href="https://instagram.com" aria-label="Instagram"><FaInstagram /></a>
              <a href="https://whatsapp.com" aria-label="WhatsApp"><FaWhatsapp /></a>
              <a href="https://linkedin.com" aria-label="LinkedIn"><FaLinkedinIn /></a>
            </div>
          </div>

          <div className="footer-nav-premium">
            <div className="nav-col-premium">
              <h4>Solutions</h4>
              <ul>
                <li><Link to="/nbfc">Ignosi BanQ</Link></li>
                <li><Link to="/mscs">Ignosi Co-op</Link></li>
                <li><Link to="/chitty">Ignosi Bid</Link></li>
                <li><Link to="/mfi">Ignosi Micro</Link></li>
              </ul>
            </div>
            <div className="nav-col-premium">
              <h4>Company</h4>
              <ul>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/careers">Careers</Link></li>
                <li><Link to="/news-events">News & Events</Link></li>
                <li><Link to="/partners">Partners</Link></li>
              </ul>
            </div>
            <div className="nav-col-premium">
              <h4>Contact</h4>
              <div className="direct-contact-premium">
                <a href="tel:+919447094230" className="contact-link-premium">
                  <FaPhoneAlt /> +91 9447 094 230
                </a>
                <a href="mailto:info@ignosi.in" className="contact-link-premium">
                  <FaEnvelope /> info@ignosi.in
                </a>
                <div className="address-premium">
                  <FaMapMarkerAlt />
                  <span>ACE-13, 4th Floor, CDAC, Technopark, Trivandrum</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom-premium">
          <div className="legal-info-premium">
            <p>© {new Date().getFullYear()} Ignosi Enterprises LLP. All Rights Reserved.</p>
          </div>
          <div className="legal-links-premium">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/compliance">Compliance</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
